import { OfferService } from '@spilca/order_ts/v1/order_web/offer_web_pb_service';
import {
  DeleteMultiOfferRequest,
  DeleteMultiOfferResponse
} from '@spilca/order_ts/v1/order_web/offer_web_pb';
import { getGrpcPromise } from '@monorepo/grpc';
import { Offer } from '@spilca/order_ts/v1/order/model_offer_pb';
import { offerConstructor } from '@monorepo/offers';

const deleteMultiOffer = (
  offers: Array<Offer.AsObject>
): Promise<DeleteMultiOfferResponse.AsObject> => {
  const request = new DeleteMultiOfferRequest();
  const formatedData = offers.map((offer) => offerConstructor(offer));
  request.setItemsList(formatedData);

  return getGrpcPromise(OfferService.DeleteMultiOffer)(request);
};

export default deleteMultiOffer;
